// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n[data-v-6f251d76] .el-form-item,[data-v-6f251d76] .el-form-item__content {\n  width: 100%;\n}\n.huobu_title[data-v-6f251d76] {\n  font-size: 16px;\n  color: #666;\n  padding-bottom: 20px;\n}\n.md20[data-v-6f251d76] {\n  margin-bottom: 20px;\n}\n.yibuhuo_title[data-v-6f251d76] {\n  padding-top: 20px;\n  border-top: 1px solid #999;\n  margin-top: 20px;\n}\n.pd20[data-v-6f251d76] {\n  padding-bottom: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
